import { roundTo } from './units.js';

/**
 * Format a stored percentage-point value (0–100 scale) for user-facing UI.
 *
 * Does **not** multiply by 100. Rounds to at most two decimal places and drops
 * unnecessary trailing zeroes (`30.90` → `30.9%`, `4` → `4%`).
 */
export function formatPercentPoints(
  value: number | null | undefined,
  empty = '—',
): string {
  if (value == null || typeof value !== 'number' || !Number.isFinite(value)) {
    return empty;
  }
  const rounded = roundTo(value, 2);
  // Avoid float artifacts like 30.90000000004 after rounding.
  const text = String(Number(rounded.toFixed(2)));
  return `${text}%`;
}
